import React, { useState, useEffect, useMemo } from "react";
import { Modal, Button, Table } from "react-bootstrap";
import { Pagination } from "../../Table/index";
import moment from "moment";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { useDispatch, useSelector } from "react-redux";
import { getMaterialItemReceiveList } from "../../../../Store/Erp/MaterialReceive/getMaterialItem";
import { getUnit } from "../../../../Store/Store/StoreMaster/Unit/Unit";

const ItemSelectionModal = ({
  show,
  onHide,
  sendSelectedItems,
  preSelectedItems = [],
  isEditMode = false,
}) => {
  const materalItemData = useSelector(
    (state) => state?.materialItemReceiveList?.user?.data
  );
  const dispatch = useDispatch();

  const project_id = localStorage.getItem("U_PROJECT_ID");

  const [selectedItems, setSelectedItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const [voucherFilter, setVoucherFilter] = useState([]);
  const [itemFilter, setItemFilter] = useState([]);

  const [filterSourceData, setFilterSourceData] = useState([]);

  useEffect(() => {
    dispatch(
      getMaterialItemReceiveList({
        project_id,
        voucher_no: voucherFilter,
        name: itemFilter,
      })
    );
    dispatch(getUnit());
  }, [dispatch, project_id, voucherFilter, itemFilter]);

  useEffect(() => {
    if (!show) return;
  
    dispatch(
      getMaterialItemReceiveList({
        project_id,
      })
    ).then((res) => {
      const data = res?.payload?.data?.data || [];
      setFilterSourceData(data);
    });
  }, [show, dispatch, project_id]);

  const tableData = materalItemData?.data || [];

  const itemsPerPage = materalItemData?.pagination?.limit || 10;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = tableData.slice(indexOfFirstItem, indexOfLastItem);

  useEffect(() => {
    if (!show) {
      setVoucherFilter([]);
      setItemFilter([]);
      setCurrentPage(1);
      setSelectedItems([]);
    }
  }, [show]);

  const voucherOptions = [
    ...new Set(filterSourceData.map((row) => row.voucher_no)),
  ].filter(Boolean).map((v) => ({
    label: v,
    value: v,
  }));
  
  const itemOptions = [
    ...new Set(filterSourceData.map((row) => row.itemsDetails?.name)),
  ].filter(Boolean).map((v) => ({
    label: v,
    value: v,
  }));

  useEffect(() => {
    if (!show) return;

    setSelectedItems(
      preSelectedItems.map((item) => ({
        ...item,
        issue_detail_id: item.issue_detail_id || item.itemsDetails?._id,
      }))
    );

    setCurrentPage(1);
  }, [show, preSelectedItems]);

  const handleCheckboxChange = (item, checked) => {
    const issueDetailId = item.itemsDetails?._id;

    if (checked) {
      // Check if already selected
      const alreadySelected = selectedItems.some(
        (i) => (i.issue_detail_id || i.itemsDetails?._id) === issueDetailId
      );

      if (!alreadySelected) {
        const itemToAdd = {
          ...item,
          ui_id: `modal_${issueDetailId}_${Date.now()}`,
          issue_detail_id: issueDetailId,
          item_id: item._id,
        };

        setSelectedItems((prev) => [...prev, itemToAdd]);
      }
    } else {
      setSelectedItems((prev) =>
        prev.filter(
          (i) => (i.issue_detail_id || i.itemsDetails?._id) !== issueDetailId
        )
      );
    }
  };

  const handleSelectAll = (checked) => {
    const pageItems = currentItems;

    if (checked) {
      const newItems = pageItems
        .filter((pageItem) => {
          const issueDetailId = pageItem.itemsDetails?._id;
          return !selectedItems.some(
            (selected) =>
              (selected.issue_detail_id || selected.itemsDetails?._id) ===
              issueDetailId
          );
        })
        .map((item) => ({
          ...item,
          ui_id: `modal_${item.itemsDetails._id}_${Date.now()}`,
          issue_detail_id: item.itemsDetails._id,
          item_id: item._id,
        }));

      setSelectedItems((prev) => [...prev, ...newItems]);
    } else {
      const pageDetailIds = new Set(
        pageItems.map((item) => item.itemsDetails?._id)
      );
      setSelectedItems((prev) =>
        prev.filter(
          (item) =>
            !pageDetailIds.has(item.issue_detail_id || item.itemsDetails?._id)
        )
      );
    }
  };

  const handleAddSelected = () => {
    const prevIds = new Set(
      preSelectedItems.map((item) => item.issue_detail_id)
    );

    const newlySelectedItems = selectedItems.filter(
      (item) => !prevIds.has(item.issue_detail_id)
    );

    sendSelectedItems(newlySelectedItems);
    onHide();
    setCurrentPage(1);
  };

  const isPageAllSelected = () => {
    if (currentItems.length === 0) return false;

    return currentItems.every((pageItem) => {
      const pageDetailId = pageItem.itemsDetails?._id;
      return selectedItems.some(
        (selected) =>
          (selected.issue_detail_id || selected.itemsDetails?._id) ===
          pageDetailId
      );
    });
  };

  const isItemSelected = (item) => {
    const itemDetailId = item.itemsDetails?._id;
    return selectedItems.some(
      (selected) =>
        (selected.issue_detail_id || selected.itemsDetails?._id) ===
        itemDetailId
    );
  };

  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Select Items</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* FILTER SECTION */}
        <div className="row g-3">
          <div className="col-md-4">
            <div className="input-block local-forms">
              <MultiSelect
                value={voucherFilter}
                options={voucherOptions}
                onChange={(e) => {
                  setVoucherFilter(e.value);
                  setCurrentPage(1);
                }}
                filter
                showClear
                placeholder="Select Voucher No"
                className="w-100"
                appendTo="self"
                display="chip"
              />
            </div>
          </div>

          <div className="col-md-4">
            <div className="input-block local-forms">
              <MultiSelect
                value={itemFilter}
                options={itemOptions}
                onChange={(e) => {
                  setItemFilter(e.value);
                  setCurrentPage(1);
                }}
                filter
                showClear
                placeholder="Select Item Name"
                className="w-100"
                appendTo="self"
                display="chip"
              />
            </div>
          </div>
        </div>

        <div className="table-responsive" style={{ maxHeight: "400px" }}>
          <Table
            striped
            bordered
            hover
            responsive
            className="align-middle mb-0"
          >
            <thead className="table-light text-nowrap sticky-top">
              <tr>
                <th>
                  <input
                    type="checkbox"
                    onChange={(e) => handleSelectAll(e.target.checked)}
                    checked={isPageAllSelected()}
                  />
                </th>
                <th>Voucher No</th>
                <th>Item Name</th>
                <th>Unit</th>
                <th>Category</th>
                <th>Heat No.</th>
                <th>Total Qty</th>
                <th>Pending Qty</th>
                <th>Transaction Date</th>
                <th>Party Name</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.length === 0 ? (
                <tr className="">
                  <td colSpan="10" className="text-center py-3 fw-bold">
                    No Data Available
                  </td>
                </tr>
              ) : (
                currentItems.map((item) => (
                  <>
                    {item?.itemsDetails?.remaining_erp_qty > 0 && (
                      <>
                        <tr
                          key={item.itemsDetails._id}
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            handleCheckboxChange(item, !isItemSelected(item))
                          }
                        >
                          <td>
                            <input
                              type="checkbox"
                              className="bg-primary"
                              checked={isItemSelected(item)}
                              onChange={(e) =>
                                handleCheckboxChange(item, e.target.checked)
                              }
                              onClick={(e) => e.stopPropagation()}
                            />
                          </td>
                          <td>{item?.voucher_no || "-"}</td>
                          <td>{item?.itemsDetails?.name || "-"}</td>
                          <td>{item?.itemsDetails?.unit || "-"}</td>
                          <td>{item?.itemsDetails?.category || "-"}</td>
                          <td>{item?.itemsDetails?.heat_no || "-"}</td>
                          <td>{item?.itemsDetails?.qty || "0"}</td>
                          <td>
                            {item?.itemsDetails?.remaining_erp_qty || "0"}
                          </td>
                          <td>
                            {item?.trans_date
                              ? moment(item.trans_date).format("DD-MM-YYYY")
                              : "-"}
                          </td>
                          <td>{item?.partyData?.name || "-"}</td>
                        </tr>
                      </>
                    )}
                  </>
                ))
              )}
            </tbody>
          </Table>
        </div>

        <div className="d-flex justify-content-end mt-3 mb-2">
          <Pagination
            total={materalItemData?.pagination?.total}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={(page) => setCurrentPage(page)}
          />
        </div>
      </Modal.Body>

      <Modal.Footer className="d-flex justify-content-end">
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleAddSelected}>
          Add Selected ({selectedItems.length})
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ItemSelectionModal;
